import React from 'react';
import styled from '@emotion/styled';
import { Column, ColumnContent, IColumnProps } from './Column';
import { withTranslate } from '../../../../../shared/i18n/translate';

interface ICanceledDetailsProps extends IColumnProps {
	codeShareFlightNumber: string;
}

const StyledColumnContent = styled(ColumnContent)`
	font-weight: normal;
	max-width: 300px;
`;

export const CanceledColumn = withTranslate<ICanceledDetailsProps>(
	({ t, codeShareFlightNumber, columns }) => (
		<Column columns={columns}>
			<StyledColumnContent>
				{t('web_flight_details_canceled_description', {
					flight: codeShareFlightNumber,
				})}
			</StyledColumnContent>
		</Column>
	),
);
